module.exports = __webpack_public_path__ + "img/en.113dbe33.jpg";